{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Увімкнено",
          "DISABLED": "Вимкнено"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Надіслав",
          "BOT": "Бот",
          "FROM": "від",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "Скасувати",
        "CREATE_BUTTON_TEXT": "Створити",
        "FORM": {
          "TITLE": {
            "LABEL": "Назва",
            "PLACEHOLDER": "Будь ласка, введіть назву кампанії",
            "ERROR": "Необхідно вказати назву"
          },
          "MESSAGE": {
            "LABEL": "Текст повідомлення",
            "PLACEHOLDER": "Будь ласка, введіть повідомлення кампанії",
            "ERROR": "Необхідне повідомлення"
          },
          "INBOX": {
            "LABEL": "Вибрати \"Вхідний\" канал",
            "PLACEHOLDER": "Вибрати \"Вхідний\" канал",
            "ERROR": "Канал потрібен"
          },
          "SENT_BY": {
            "LABEL": "Надіслав",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Відправник обов'язковий"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Будь ласка, введіть URL",
            "ERROR": "Будь ласка, введіть правильний URL",
            "URL_IS_REGEXP": "Значення є регулярним виразом"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Час на сторінці (секунд)",
            "PLACEHOLDER": "Будь ласка, введіть час",
            "ERROR": "Потрібен час на сторінці"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Увімкнути кампанію",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Активувати лише протягом робочих годин"
          },
          "BUTTONS": {
            "CREATE": "Створити",
            "CANCEL": "Скасувати"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Завершено",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "Скасувати",
        "CREATE_BUTTON_TEXT": "Створити",
        "FORM": {
          "TITLE": {
            "LABEL": "Назва",
            "PLACEHOLDER": "Будь ласка, введіть назву кампанії",
            "ERROR": "Необхідно вказати назву"
          },
          "MESSAGE": {
            "LABEL": "Текст повідомлення",
            "PLACEHOLDER": "Будь ласка, введіть повідомлення кампанії",
            "ERROR": "Необхідне повідомлення"
          },
          "INBOX": {
            "LABEL": "Вибрати \"Вхідний\" канал",
            "PLACEHOLDER": "Вибрати \"Вхідний\" канал",
            "ERROR": "Канал потрібен"
          },
          "AUDIENCE": {
            "LABEL": "Аудиторія",
            "PLACEHOLDER": "Оберіть мітки клієнта",
            "ERROR": "Потрібна аудиторія"
          },
          "SCHEDULED_AT": {
            "LABEL": "Запланований час",
            "PLACEHOLDER": "Будь ласка, виберіть час",
            "ERROR": "Запланований час обов'язковий"
          },
          "BUTTONS": {
            "CREATE": "Створити",
            "CANCEL": "Скасувати"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Справді бажаєте видалити?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Видалити",
      "API": {
        "SUCCESS_MESSAGE": "Кампанію успішно видалено",
        "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз."
      }
    }
  }
}
